import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Button, message } from 'antd';
import { TwitterPicker, ColorResult } from 'react-color';
import { Descriptions, Input, Switch } from 'antd';
import { LabelSetting } from '../../../types/label';
import { BiCommand } from 'react-icons/bi';

type LabelProps = {
  labels: LabelSetting[] | null;
  type: { color: string; name: string; hidden: boolean; status?: string; shortcut?: string };
  selector: boolean;
  showSelector: (i: number) => any;
  changeColor: (i: number, color: ColorResult) => any;
  deleteLabel: (i: number) => any;
  editLabel: (i: number, newName: string, shortcut?: string) => any;
  switchHidden: (i: number) => any;
  switchStatus: (i: number) => any;
  showStatus: (i?: string) => any;
  i: number;
};

export const LabelSettings = ({
  labels,
  type,
  selector,
  showSelector,
  changeColor,
  deleteLabel,
  editLabel,
  switchHidden,
  switchStatus,
  showStatus,
  i,
}: LabelProps) => {
  const [labelName, setLabelName] = useState('');
  const [shortcut, setShortcut] = useState('');
  const [editingShortcut, setEditingShortcut] = useState<boolean>(false);

  const inputRef = useRef<any>(null);

  useEffect(() => {
    setLabelName(type.name);
    setShortcut(type.shortcut || '');
    return () => {
      setLabelName('');
      setShortcut('');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  useEffect(() => {
    if (editingShortcut) {
      inputRef?.current?.focus();
    }
  }, [editingShortcut]);

  const onChangeShortcut = useCallback(
    (value: string) => {
      if (labels) {
        const checkShortcut = labels.filter((_, index) => index !== i).find(l => l.shortcut === value && value !== '');
        if (!checkShortcut) {
          setShortcut(value);
        } else {
          message.error(`Shortcut "${value}" already in use`);
        }
      }
    },
    [labels, i]
  );

  return (
    <div style={{ width: '100%' }} key={`label-${type.name}`}>
      <Descriptions.Item label="Classes">
        <Input
          name="name"
          style={{
            width: '140px',
            margin: '10px 10px 5px 5px',
            padding: '5px',
            textAlign: 'center',
          }}
          value={labelName}
          onChange={e => {
            setLabelName(e.target.value);
          }}
          onBlur={e => editLabel(i, labelName, shortcut)}
        />
        <Button
          type="default"
          style={{ backgroundColor: type.color, marginRight: '10px' }}
          onClick={() => {
            showSelector(i);
          }}>
          <span> </span>
        </Button>
        {selector && (
          <div style={{ position: 'absolute', zIndex: 100, left: '188px' }}>
            <TwitterPicker
              color={type.color}
              onChange={color => {
                changeColor(i, color);
              }}
            />
          </div>
        )}
        <Switch
          style={{ marginRight: 10 }}
          checkedChildren="Visible"
          unCheckedChildren="Hidden"
          checked={!type.hidden}
          onChange={() => {
            switchHidden(i);
          }}
        />
        <Button
          type="default"
          style={{
            color: showStatus(type.status)[0],
            backgroundColor: showStatus(type.status)[1],
            marginRight: '10px',
            width: '110px',
          }}
          onClick={() => {
            switchStatus(i);
          }}>
          {showStatus(type.status)[2]}
        </Button>
        <Button
          type="default"
          onClick={() => {
            deleteLabel(i);
          }}>
          Remove
        </Button>
        {shortcut || editingShortcut ? (
          <Input
            ref={inputRef}
            name="shortcut"
            type="text"
            maxLength={1}
            style={{
              width: '40px',
              margin: '10px 0px 5px 10px',
              padding: '4px 6px',
              textAlign: 'center',
            }}
            value={shortcut}
            onFocus={() => setEditingShortcut(true)}
            onChange={e => {
              onChangeShortcut(e.target.value.toUpperCase());
            }}
            onBlur={e => {
              editLabel(i, labelName, shortcut);
              setEditingShortcut(false);
            }}
          />
        ) : (
          <Button
            style={{
              padding: '2px 1px',
              marginLeft: '10px',
            }}
            onClick={() => {
              setEditingShortcut(true);
            }}>
            <BiCommand
              style={{
                width: '36px',
                marginBottom: '-2px',
                color: '#999',
              }}
            />
          </Button>
        )}
      </Descriptions.Item>
    </div>
  );
};
